(function(){

  var doc = document.documentElement;
  var w = window;

  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;

  var header = document.getElementById('shopify-section-header');

  var checkScroll = function() {

    /*
    ** Find the direction of scroll
    ** 0 - initial, 1 - up, 2 - down
    */

    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) {
      //scrolled up
      direction = 2;
    }
    else if (curScroll < prevScroll) {
      //scrolled down
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    if (curScroll < 50) {
      header.classList.add('top-location');
      if(typeof stickySidebar !== 'undefined' && stickySidebar) {
        stickySidebar.options.topSpacing = 200;
        stickySidebar.updateSticky({
          type: 'scroll'
        });
      }
    }

    prevScroll = curScroll;
  };

  var toggleHeader = function(direction, curScroll) {
    if (direction === 2 && curScroll > 150) {
      header.classList.add('hide');
      header.classList.remove('top-location');
      prevDirection = direction;
      // if(typeof stickySidebar !== 'undefined' && stickySidebar) {
      //   // stickySidebar.options.topSpacing = 80;
      //   // stickySidebar.updateSticky({
      //   //   type: 'scroll'
      //   // });
      //   var interval = window.setInterval(function(){
      //     //stickySidebar.sidebarInner.style.top = stickySidebar.sidebarInner.offsetTop - 1 + 'px';
      //
      //     if (stickySidebar.sidebarInner.position == 'relative') {
      //       stickySidebar.sidebarInner.style.top = 0;
      //       clearInterval(interval);
      //     } else if (stickySidebar.sidebarInner.offsetTop <= 80) {
      //       clearInterval(interval);
      //     }
      //     //
      //     // if (stickySidebar.sidebarInner.offsetTop <= 80) {
      //     //   clearInterval(interval);
      //     // } else if (stickySidebar.sidebarInner.position == 'relative') {
      //     //   stickySidebar.sidebarInner.style.top = 0;
      //     //   clearInterval(interval);
      //     // }
      //   }, 1);
      //   // while(stickySidebar.options.topSpacing > 80 && stickySidebar.options.topSpacing > 0) {
      //   //   setTimeout(function(){
      //   //     stickySidebar.options.topSpacing = stickySidebar.options.topSpacing - 1;
      //   //     stickySidebar.updateSticky({
      //   //       type: 'scroll'
      //   //     });
      //   //   }, 5);
      //   // }
      // }
    }
    else if (direction === 1) {
      header.classList.remove('hide');
      prevDirection = direction;
      // if(typeof stickySidebar !== 'undefined' && stickySidebar) {
      //   // stickySidebar.options.topSpacing = 180;
      //   // stickySidebar.updateSticky({
      //   //   type: 'scroll'
      //   // });
      //
      //   var interval1 = window.setInterval(function(){
      //     console.log('inteval' + stickySidebar.sidebarInner.offsetTop);
      //     console.log('2position' + stickySidebar.sidebarInner.style.position);
      //     if (stickySidebar.sidebarInner.style.position == "relative") {
      //       console.log('IF');
      //       stickySidebar.sidebarInner.style.top = 0;
      //       clearInterval(interval1);
      //     } else {
      //       if (stickySidebar.sidebarInner.offsetTop >= 180) {
      //         clearInterval(interval1);
      //       }
      //     }
      //
      //     // if (stickySidebar.sidebarInner.position == 'relative') {
      //     //   stickySidebar.sidebarInner.style.top = 0;
      //     //   clearInterval(interval1);
      //     // } else if (stickySidebar.sidebarInner.offsetTop >= 180) {
      //     //   clearInterval(interval1);
      //     // }
      //   }, 1);
      //   // while(stickySidebar.options.topSpacing < 180) {
      //   //   setTimeout(function(){
      //   //     stickySidebar.options.topSpacing = stickySidebar.options.topSpacing + 1;
      //   //     stickySidebar.updateSticky({
      //   //       type: 'scroll'
      //   //     });
      //   //   }, 5);
      //   // }
      // }
    }
  };

  window.addEventListener('scroll', checkScroll);

  if (document.querySelector('.btn-check-code')) {
    document.querySelector('.btn-check-code').addEventListener('click', (evt) => {
      serialNumberCheck();
    });
  }

  var t = {
      state: {
          wrappingWidth: "",
          wrappingHeight: "",
          imageWidth: "",
          imageHeight: "",
          imagePosition: ""
      },
      init: function() {
          this.addEventHandler()
      },
      reposition: function() {
          var h = this;
          jQuery(".highlight2020").each(function(t, i) {
              h.actualizeState(i);
              var o,
                  s = jQuery(i).get(0).querySelector("canvas");
              s && (jQuery(s).attr({
                  width: h.state.wrappingWidth,
                  height: h.state.wrappingHeight
              }), (o = s.getContext("2d")).clearRect(0, 0, s.width, s.height)),
              jQuery(i).find(".highlight__hotspot").each(function(t, i) {
                  var e = jQuery(i),
                      a = e.data("offset-top"),
                      n = e.data("mobile-top"),
                      i = e.data("mobile-left");
                  jQuery(window).width() < 992 ? e.css({
                      top: n + "%",
                      left: i + "%"
                  }) : (e.css({
                      top: a + "%",
                      left: "auto"
                  }), h.repositionSvgPath(e, s, o))
              })
          })
      },
      actualizeState: function(t) {
          this.state.wrappingWidth = parseFloat(jQuery(t).find(".highlight2020__imageWrapper").css("width")),
          this.state.wrappingHeight = parseFloat(jQuery(t).find(".highlight2020__imageWrapper").css("height")),
          this.state.imageWidth = parseFloat(jQuery(t).find(".image_wrap img").css("width")),
          this.state.imageHeight = parseFloat(jQuery(t).find(".image_wrap img").css("height")),
          this.state.imagePosition = jQuery(t).find(".image_wrap").data("imgpos")
      },
      repositionSvgPath: function(t, i, e) {
          var a,
              n,
              o,
              s,
              h,
              g,
              r,
              l = this,
              d = t.data("svgstart");
          d && (a = d ? d.split(",") : [0, 0], n = parseFloat(l.state.imageWidth) * parseFloat(a[0]) / 100, o = parseFloat(l.state.imageHeight) * parseFloat(a[1]) / 100, s = 0, h = parseFloat(l.state.wrappingHeight) * parseFloat(t.data("offset-top")) / 100, g = .8 * parseFloat(l.state.imageWidth), r = parseFloat(l.state.imageWidth), "center" !== l.state.imagePosition && "right" !== l.state.imagePosition || (s = parseFloat(l.state.wrappingWidth) - parseFloat(l.state.imageWidth)), "center" === l.state.imagePosition && (s /= 2), d = parseFloat(t.height()), h += Math.floor(d / 2), 2 === a.length && t.parent().hasClass("highlightElementsRight") && ("center" === l.state.imagePosition ? (r = l.state.wrappingWidth - t.width()) < g && (g = r - 125, g -= s) : r += s, n += s, g += s, r -= 15, e && (e.beginPath(), e.moveTo(n, o), e.setLineDash([]), l.pointdebug("circle", n, o), e.arc(n, o, 8, 0, 2 * Math.PI), e.fill(), e.closePath(), e.beginPath(), e.moveTo(n, o), e.setLineDash([3, 3]), e.lineTo(g, h), l.pointdebug("Knick", g, h), e.lineTo(r, h), l.pointdebug("Ende", r, h), e.moveTo(n, o), e.stroke(), e.closePath())), 2 === a.length && t.parent().hasClass("highlightElementsLeft") && (g = .2 * parseFloat(l.state.imageWidth), "center" === l.state.imagePosition ? g < (r = t.width()) && (g = r + 125, g -= s) : r = parseFloat(s), n += s, g += s, r += 15, e && (e.beginPath(), e.moveTo(n, o), e.setLineDash([]), l.pointdebug("circle", n, o), e.arc(n, o, 8, 0, 2 * Math.PI), e.fill(), e.closePath(), e.beginPath(), e.moveTo(n, o), e.setLineDash([3, 3]), l.pointdebug("Knick", g, h), e.lineTo(g, h), l.pointdebug("Ende", r, h), e.lineTo(r, h), e.moveTo(n, o), e.stroke(), e.closePath())))
      },
      imageIsBiggerThenHalf: function(t) {
          return t < this.state.imageWidth / 2
      },
      pointdebug: function(t, i, e) {},
      addEventHandler: function() {
          var i = this;
          jQuery(".highlight2020 .mobile__trigger").on("click", function() {
              var t = jQuery(this).find("+ .content").clone();
              i.setOverlayContentAndShow(t)
          }),
          jQuery(window).on("resize", function() {
              i.reposition()
          }),
          jQuery(".highlight2020 img").on("load", function() {
              i.reposition()
          }),
          document.querySelectorAll(".highlight2020 img").forEach(function(t) {
              t.complete && i.reposition()
          })
      },
      setOverlayContentAndShow: function(t) {
          var i = jQuery("#highligh2020overlay"),
              e = this;
          0 === i.length ? (jQuery("body").append('<div id="highligh2020overlay" style="display: none;"><div class="contentwrapper"><div class="content"></div><div class="close">Close</div></div></div>'), window.requestAnimationFrame(function() {
              e.setOverlayContentAndShow(t)
          })) : (i.find(".content").html(t), i.show(), i.find(".close").off("click").on("click", function() {
              i.hide()
          }))
      }
  };

  t.init();
  if(window.location.hash == "#recover") {
    resetPassword();
  }
  resetPasswordSuccess();

})();

function switchGalleryVideo(blockId) {
  document.getElementById('gallery-main-video').innerHTML = document.getElementById('video-embed-' + blockId).innerHTML;
  document.getElementById('gallery-main-video-description').innerHTML = document.getElementById('video-description-' + blockId).innerHTML;
  document.querySelector('.gallery-thumbs-video.active').classList.remove('active');
  document.getElementById('gallery-thumb-' + blockId).classList.add('active');
}

function serialNumberCheck() {
  let xhr = new XMLHttpRequest();

  xhr.open("POST", "https://www.pbswisstools.com/en/ajax/seriennummer");

  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('Access-Control-Allow-Origin', '*');

  xhr.onload = () => console.log(xhr.responseText);

  xhr.send('tx_pbstproduct_product%5Bserial%5D=' + document.querySelector('.check-code-section input').value);

  document.getElementById('check-code-result').innerHTML = "The desired number could not be found. For more information, please contact us at info@pbswisstools.com.";
}

function resetPassword() {
  document.getElementById('login-form').classList.add("d-none");
  document.getElementById('password-form').classList.remove("d-none");
}

function cancelResetPassword() {
  document.getElementById('password-form').classList.add("d-none");
  document.getElementById('login-form').classList.remove("d-none");
}



function resetPasswordSuccess() {
  var rs = document.getElementById('resetSuccess');
  var fS = document.querySelector('.reset');
  var re = document.getElementById('recover-email');

  if (!rs || !fS) {
    return;
  }

  if (re.classList.contains('reset-success')) {
    rs.classList.remove('d-none');
  }
}
